import { MediaFormatType } from "@/types/ModuleOptionsType";

export const generateMediaFormat = (format: MediaFormatType) => {
  return `format-${format.mobile}-mobile format-${format.tablet}-tablet format-${format.desktop}-desktop format-${format.fullhd}-fullhd`;
};
